var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutTri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 229.865,
    height: 214.19,
    viewBox: "0 0 229.865 214.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2529.848 -962.503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2712.1,1068.592l-30.111-53.57L2713.5,962.5h46.217v107.19l-47.431.448Z",
    fill: "#9acffd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2712.1,1068.592l-30.111-53.57L2713.031,963l46.681-.5v107.19H2712.1Z",
    transform: "translate(0 107)",
    fill: "#988cba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2589.9,1068.592l31.862-52.869,60.284-.7,31.013,54.97-30.758,51.957-62.289-.483Z",
    fill: "#373a88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2589.9,1039.379l14.488-24.04,27.412-.32,14.1,25-13.986,23.626-28.324-.22Z",
    transform: "translate(-60.052 87.115)",
    fill: "#f1f9ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutTri);
export default __webpack_public_path__ + "static/media/about-tri.dc2f25b86ff7bd974d6fccb37b69f306.svg";
export { ForwardRef as ReactComponent };